const e=t=>t?{minWidth:"16px",minHeight:"16px",padding:"5px"}:{width:"6px",height:"6px"};export{e as retrieveContentStyles};
